import { useState } from "react";
import EmiratesInputID from "@/app/components/common/actions/inputs-b/EmiratesInputID";
import { useNavigate } from "react-router-dom";

export default function EmiratesID() {
  const navigate = useNavigate();

  const [emiratesId, setEmiratesId] = useState("");
  const [error, setError] = useState("");

  const validateEmiratesId = (value: string) => {
    if (!value) {
      return "Emirates ID is required";
    }

    if (!/^\d{15}$/.test(value)) {
      return "Emirates ID must be 15 digits";
    }

    return "";
  };

  const handledashboard = () => {
    const validationError = validateEmiratesId(emiratesId);

    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    navigate("/onboarding/uaePassConnect");
  };

  return (
    <div className="gx-login-card">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <div className="gx-login-card-details">
            <h2 className="gx-h2-l">
              Enter your
              <span className="gx-h2-b"> Emirates ID</span>
            </h2>
          </div>
        </div>

        <div className="col-span-12">
          <div className="mb-3 mt-5">
            <EmiratesInputID
              label="Emirates ID"
              value={emiratesId}
              onChange={(value) => {
                setEmiratesId(value);
                if (error) {
                  setError(validateEmiratesId(value));
                }
              }}
              validationMessage={error}
            />
          </div>
        </div>

        <div className="col-span-12">
          <div className="login-continue-btn">
            <button className="gx-h4-eb" onClick={handledashboard}>
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}